import { useState, useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useSearch() {
  const [query, setQuery] = useState('');
  const [filters, setFilters] = useState<Record<string, string>>({});

  const { data, isLoading, error } = useQuery<{ success: boolean; data: any[]; total: number; page: number; totalPages: number }>({
    queryKey: ['search', query, filters],
    queryFn: () => api.search({ q: query, ...filters }),
    enabled: query.length > 0 || Object.keys(filters).length > 0,
  });

  const search = useCallback((q: string) => {
    setQuery(q);
  }, []);

  const updateFilter = useCallback((key: string, value: string) => {
    setFilters((prev) => {
      if (!value) {
        const { [key]: _, ...rest } = prev;
        return rest;
      }
      return { ...prev, [key]: value };
    });
  }, []);

  const clearFilters = useCallback(() => {
    setQuery('');
    setFilters({});
  }, []);

  return {
    query,
    filters,
    results: data?.data || [],
    total: data?.total || 0,
    page: data?.page || 1,
    totalPages: data?.totalPages || 1,
    isLoading,
    error,
    search,
    updateFilter,
    clearFilters,
  };
}
